import { useBreakpoint } from './breakpoints.js';

export function useIsMobile() {
  return useBreakpoint({ max: 'sm' });
}
